import { css, SerializedStyles } from "@emotion/react";

// NOTE: Prettier trigger by commit hook remove camelCasing from CSS-in_JS
import theme from "../../styles/theme";
import { blue, greyDark, greySecondary as grey } from "../../styles/variables";

export const radio = (spacing = 0): SerializedStyles => css`
  margin-right: ${theme.spacing(spacing)}px;

  .MuiFormControlLabel-root {
    margin-right: 0;
  }
`;

export const radioWithBox = (spacing = 0, selected = false): SerializedStyles => css`
  margin-top: ${theme.spacing(1)}px;
  margin-right: ${theme.spacing(spacing)}px;
  padding: 5px 22px;
  border-radius: 8px;
  border: solid ${selected ? "2px" : "1px"} ${selected ? blue : grey};
  flex: 1;

  &:last-child {
    margin-right: 0;
  }

  .MuiFormControlLabel-root {
    margin-right: 0;
  }

  .MuiFormControlLabel-label {
    font-size: 14px;
    font-weight: bold;
  }
`;

export const note = css`
  display: block;
  color: ${greyDark};
`;

export const icon = css`
  margin-left: ${theme.spacing(1)}px;

  > svg {
    vertical-align: middle;
  }
`;

export const iconTip = css`
  display: inline-block;
`;
